import { SmartCaptcha } from '@yandex/smart-captcha';

type SmartCaptchaFieldProps = {
  siteKey: string;
  localMode: boolean;
  resetKey: number;
  error: string | null;
  onSuccess: (token: string) => void;
  onExpired: () => void;
  onWidgetError: () => void;
  onRetry: () => void;
};

export function SmartCaptchaField({
  siteKey,
  localMode,
  resetKey,
  error,
  onSuccess,
  onExpired,
  onWidgetError,
  onRetry,
}: SmartCaptchaFieldProps): JSX.Element {
  if (localMode) {
    return (
      <div className="space-y-2 rounded-md border border-border bg-muted/40 p-3 text-sm">
        <p>
          Локальный режим: внешняя CAPTCHA отключена только для development-сервера.
        </p>
        <button
          type="button"
          className="rounded-md border border-border bg-background px-3 py-2 font-semibold hover:border-primary"
          onClick={() => onSuccess('webstat-local-development-captcha')}
        >
          Пройти локальную проверку
        </button>
      </div>
    );
  }

  if (!siteKey) {
    return (
      <div
        role="alert"
        className="rounded-md border border-destructive/40 bg-destructive/10 p-3 text-sm"
      >
        Отправка заявок временно недоступна.
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <p className="text-sm font-semibold">Проверка безопасности *</p>
      <div className="min-h-[100px]">
        <SmartCaptcha
          key={resetKey}
          sitekey={siteKey}
          language="ru"
          onSuccess={onSuccess}
          onTokenExpired={onExpired}
          onNetworkError={onWidgetError}
          onJavascriptError={onWidgetError}
        />
      </div>
      {error ? (
        <div className="flex flex-wrap items-center gap-3">
          <p role="alert" className="text-sm text-destructive">
            {error}
          </p>
          <button
            type="button"
            className="rounded-md border border-border bg-background px-3 py-2 text-sm font-semibold hover:border-primary"
            onClick={onRetry}
          >
            Перезагрузить CAPTCHA
          </button>
        </div>
      ) : null}
    </div>
  );
}
